import React from 'react'
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import ComplianceForm from "./ComplianceController/ComplianceForm";

import { useAddComplianceMutation } from "store/services/complianceApi";

import { useAppMeta } from "hooks";

const ComplianceCreateScreen = () => {

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Compliance", path: "/app/crm/compliance/list" },
    { title: "New Compliance" }];

  const [createCompliance, { isLoading: creatingCompliance }] =
    useAddComplianceMutation();

  // methods
  const handleAddCompliance = async (data) => {

    try {
      const { _id } = await createCompliance(data).unwrap();
      toast.success("Compliance Created !");
      navigate(`/app/crm/compliance/${_id}/detail`)
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could Not Created Compliance !"
      );
    }
  }
  useAppMeta("New Compliance");
  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingCompliance}>
      <BreadcrumbLayout.Paper>
        <ComplianceForm isBusy={creatingCompliance} onSubmit={handleAddCompliance} />
      </BreadcrumbLayout.Paper>

    </BreadcrumbLayout>
  )
}

export default ComplianceCreateScreen